import { notificationSchema } from "@features/vessel-call/vessel-call-status/PortServices/flow/utils";
import i18n from "i18next";
import { z } from "zod";
import { createAtcSchema, withAtcAfterAtsValidation } from "./sharedClosePortServiceSchemas";

const LANG_BASE = "vessel-call.port-services.fields";

const createWasteResiduesForDischargeFacilitySchema = () =>
  z.object({
    wasteResiduesForDischargeFacility: z
      .array(
        z.object({
          marpolAnnexIOil: z.string().optional(),
          otherSpecifyDetails: z.string().optional(),
          quantityM3: z.number().optional(),
        }),
      )
      .optional(),
  });

const createSlopsDisposalDocumentsSchema = () =>
  z.object({
    slopsDisposalDocuments: z
      .array(
        z.object({
          documentUrl: z.string().optional(),
          documentName: z.string().optional(),
          fileType: z.string().optional(),
        }),
      )
      .superRefine((val, ctx) => {
        const hasDocument =
          !!val?.length && val.every((document) => !!document.documentUrl?.trim());

        if (!hasDocument) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ["slopsDisposalDocuments"],
            message: i18n.t("form-validation.required", {
              label: i18n.t(`${LANG_BASE}.slops-disposal-images`),
            }),
          });
        }
      }),
  });

const createServiceReportAttachmentSchema = () =>
  z.object({
    serviceReportAttachment: z
      .object({
        documentUrl: z.string().optional(),
        documentName: z.string().optional(),
        fileType: z.string().optional(),
      })
      .superRefine((val, ctx) => {
        const hasDocument = !!val?.documentUrl?.trim();

        if (!hasDocument) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ["serviceReportAttachment"],
            message: i18n.t("form-validation.required", {
              label: i18n.t(`${LANG_BASE}.service-report-attachment`),
            }),
          });
        }
      }),
  });

export const closeHSESlopsDisposalSchema = (ats?: string | Date | null) =>
  withAtcAfterAtsValidation(
    (createAtcSchema("required") as z.AnyZodObject)
      .merge(createSlopsDisposalDocumentsSchema())
      .merge(createServiceReportAttachmentSchema())
      .merge(createWasteResiduesForDischargeFacilitySchema())
      .merge(notificationSchema),
    ats,
  );

export type CloseHSESlopsDisposalSchema = z.infer<ReturnType<typeof closeHSESlopsDisposalSchema>>;
